import React, { Component } from 'react'
import AppHeader from './AppHeader'
import ConfigModal from './ConfigModal'
import SideNav from './SideNav'
import { logout } from '../helpers/auth'
import { logo, title } from '../config/constants'

class Main extends Component {
  constructor(...props) {
    super(...props)

    const mobileMode = document.documentElement.clientWidth <= 768

    this.state = {
      configModal: false,
      navOpen: !mobileMode,
      mobileMode: mobileMode
    }

    this.hideNav = this.hideNav.bind(this)
    this.toggleNav = this.toggleNav.bind(this)
  }

  componentDidMount() {
    window.onresize = event => {
      const mobileMode = document.documentElement.clientWidth <= 768
      this.setState({
        navOpen: !mobileMode,
        mobileMode: mobileMode
      })
    }
  }

  hideNav() {
    this.setState({
      navOpen: false
    })
  }

  toggleNav(navOpen = !this.state.navOpen) {
    this.setState({ navOpen })
  }

  render() {
    const contentWrapperStyles = { margin: '0' }
    const sideNavStyles = {}
    if (!this.state.mobileMode) {
      contentWrapperStyles.margin = '24px'
      sideNavStyles.marginLeft = this.state.navOpen ? '256px' : '0'
      sideNavStyles.transition = 'margin 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms'
    }

    let configModal
    if (this.state.configModal) {
      configModal = <ConfigModal signOut={() => logout()} />
    }

    return (
      <div>
        <SideNav
          hideNav={this.hideNav}
          pathname={this.props.location.pathname}
          logo={logo}
          mobileMode={this.state.mobileMode}
          open={this.state.navOpen}
          push={this.props.push}
          title={title}
          toggleNav={this.toggleNav}
        />
        {configModal}
        <div style={sideNavStyles}>
          <AppHeader
            mobileMode={this.state.mobileMode}
            navOpen={this.state.navOpen}
            title={title}
            toggleNav={this.toggleNav}
            signOut={() => logout()}
          />
          <div style={{
            paddingTop: '64px',
            minHeight: '400px'
          }}>
            <div style={contentWrapperStyles}>
              {this.props.children}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Main



// WEBPACK FOOTER //
// ./src/components/Main.js